<template>
  <v-container fluid grid-list-xl>

    <v-layout row wrap>

      <v-flex xs12 v-if="showError">
        <v-alert
        v-model="showError"
        type="error"
        icon="warning"
        dismissible>
          {{ errorMessage }}
        </v-alert>
      </v-flex>

      <v-flex xs12 sm2>Avatar:</v-flex>
      <v-flex xs12 sm10>
        <v-avatar
        slot="activator"
        :color="photoURL ? 'white' : 'primary'">
          <img
          v-if="photoURL"
          :src="photoURL"
          :alt="displayName"
          />
          <v-icon
          v-if="!photoURL"
          dark>account_circle</v-icon>
        </v-avatar>
      </v-flex>

      <v-flex xs12 sm2>Name:</v-flex>
      <v-flex xs12 sm10>
        <v-layout row wrap>
          <v-flex v-if="!changeName">{{ displayName }}</v-flex>
          <v-text-field
          v-if="changeName"
          v-model="name"
          type="text"
          :disabled="isUpdatingUser"
           ></v-text-field>

          <v-spacer></v-spacer>

          <v-btn
          v-if="!changeName"
          @click="name = displayName; changeName = true"
          color="primary"
          :disabled="isUpdatingUser">
            Change name
          </v-btn>
          <v-btn
          v-if="changeName"
          @click="changeName = false"
          :disabled="isUpdatingUser">
            Cancel
          </v-btn>
          <v-btn
          v-if="changeName"
          @click="confirmChangeName"
          :disabled="isUpdatingUser">
            Save name
          </v-btn>
        </v-layout>
      </v-flex>

      <v-flex xs12 sm2>Email:</v-flex>
      <v-flex xs12 sm10>{{ email }}</v-flex>

    </v-layout>

    <v-layout row wrap>

      <v-flex xs12 sm6>
        <ProviderDetailsCard provider="Google" />
      </v-flex>

      <v-flex xs12 sm6>
        <ProviderDetailsCard provider="Facebook" />
      </v-flex>

      <v-flex xs12 sm6>
        <ProviderEmailCard />
      </v-flex>

    </v-layout>

  </v-container>
</template>

<script>
// import { /*mapGetters,*/ mapState } from 'vuex';
import { createNamespacedHelpers } from 'vuex'
const { mapState, mapActions } = createNamespacedHelpers('auth')
// import { auth } from '@/firebase.js';
import ProviderDetailsCard from '@/components/auth/ProviderDetailsCard.vue';
import ProviderEmailCard from '@/components/auth/ProviderEmailCard.vue';

export default {
  name: 'User',
  components: {
    ProviderDetailsCard,
    ProviderEmailCard
  },
  data() {
    return {
      debug: false,
      showError: false,
      errorMessage: '',

      changeName: false,
      name: ''
    }
  },
  computed: {
    ...mapState({
      user: state => state.user, // map `this.user` to `this.$store.state.users.user`
      isUpdatingUser: state => state.isUpdatingUser, // map `this.user` to `this.$store.state.users.isUpdatingUser`
    }),
    displayName() {
      if (!this.user || !this.user.displayName) return '';
      else return this.user.displayName;
    },
    photoURL() {
      if (!this.user || !this.user.photoURL) return null;
      else return this.user.photoURL;
    },
    email() {
      if (!this.user || !this.user.email) return null;
      else return this.user.email;
    }
  },

  methods: {
    ...mapActions([
      'updateUser' // map `this.updateUser()` to `this.$store.dispatch('users/updateUser')`
    ]),

    confirmChangeName() {
      if (this.debug) console.log(this.$options.name+'.confirmChangeName() name:',this.name);
      this.updateUser({ displayName: this.name })
      .then(() => {
        if (this.debug) console.log(this.$options.name+'.confirmChangeName() name updated.');
        this.changeName = false;
        this.showError = false;
      })
      .catch((error) => {
        if (this.debug) console.log(this.$options.name+'.confirmChangeName() updating name error:',error);
        this.errorMessage = error;
        this.showError = true;
      })
    }

  }
}
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
.v-avatar[left] {
  margin-right: 16px;
}
</style>